import {DodgerBlueColor} from '../../cmsMainStyle'

const circulationCreateFormStyle = theme => ({
	root: {
		height: window.outerHeight - (window.outerHeight - window.innerHeight + 140),
		overflowY: "auto",
		overflowX: "hidden",
		paddingTop: theme.spacing(1),
	},

	addFileBtnArea: {
		textAlign: "center",
		paddingTop: theme.spacing(1),
		paddingBottom: theme.spacing(1),
	},

	messageRecipientArea: {
		'& > *': {
			margin: theme.spacing(0.5),
		  },
	},

	addFileBtn: {
		background: DodgerBlueColor[11],
		'&:hover': {
			background: DodgerBlueColor[13],
		},

		marginTop: theme.spacing(1),
		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),
	},

	btnArea: {
		paddingTop: theme.spacing(2),
		paddingBottom: theme.spacing(2),
	},

	errorMsg: {
		marginTop: theme.spacing(0.5),
		marginLeft: theme.spacing(2)
	},

	popoverMain: {
		padding: theme.spacing(2)
	},

	popoverMember: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
	}
})

export {circulationCreateFormStyle}